import {useEffect, useLayoutEffect} from "react";
import {useConfig} from "../../hooks/useConfig";
import {getSafeIframeSrc} from "../../utils/helpers";

export default function MarketplacePage({setPageIdentifier}) {
    let config = useConfig();
    useLayoutEffect(() => {
        setPageIdentifier("Marketplace");
    }, []);
    return (
        <iframe
            id={"engageMarketplaceIframe"}
            allow={"microphone; clipboard-write *"}
            allowFullScreen={true}
            style={{width: "100%", height: "100%", border: "none", background: "#f7f7f7"}}
            src={getSafeIframeSrc(config.marketplace_url)}
            spellCheck={false}
        >
        </iframe>
    );
}